import { CircularProgress } from "@material-ui/core";
import { RouterState } from "found";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { NoRouteView } from "../components/no-route-view";
import { ProposalErrorProvider } from "../components/shareable-proposal/hooks/ProposalErrorContext";
import { SharedProposalProvider } from "../components/shareable-proposal/hooks/SharedProposalProvider";
import { ProposalLayout } from "../components/shareable-proposal/ProposalLayout";
import { useFeatureFlag } from "../launch-darkly";
import { page, PageEvents } from "../util/analytics.util";
import { useFullStory } from "../util/fullstory";

export interface IProps extends RouterState {
  location: Location;
  redirect: string;
}

const ProposalPage = (props: IProps) => {
  const { identify } = useFullStory();
  const [canAccessAI, canAccessAILoading] = useFeatureFlag("ClockwiseAI");
  const [canShareProposal, canShareProposalLoading] = useFeatureFlag("ShareableProposals");
  const proposalId = props.match.params.proposalId;
  const hasAccess = canAccessAI && canShareProposal;

  useEffect(() => {
    page(PageEvents.SHARED_PROPOSAL, { hasAccess: hasAccess });
  }, []);

  useEffect(() => {
    identify();
  }, [identify]);

  if (canAccessAILoading || canShareProposalLoading) {
    return <CircularProgress />;
  } else if (!canAccessAI) {
    return <NoRouteView />;
  }

  return (
    <>
      <SharedProposalProvider proposalId={proposalId}>
        <Helmet>
          <title>Proposal · Clockwise</title>
        </Helmet>
        <div className="cw-min-w-[280px] cw-bg-default cw-w-full cw-h-full cw-flex cw-flex-col cw-items-center">
          <ProposalErrorProvider>
            <ProposalLayout />
          </ProposalErrorProvider>
        </div>
      </SharedProposalProvider>
    </>
  );
};

export default ProposalPage;
